import { Box, CircularProgress, Stack, Typography } from '@mui/material'

import { useController } from '../hooks/useController'
import { useRotatingText } from '../hooks/useRotatingText'
import { useTexts } from '../useTexts'
import { GearsAnimation } from './GearsAnimation'
import { OptimizationConfigPanel } from './OptimizationConfigPanel'

export function Step1() {
  const texts = useTexts()
  const {
    data: { progress },
  } = useController()
  const rotatingText = useRotatingText(progress)

  return (
    <Stack alignItems="center" sx={{ pt: '14px', pb: '15px' }}>
      <Box sx={{ mb: '24px' }}>
        <GearsAnimation size={64} />
      </Box>

      <Typography variant="subtitle1" sx={{ mb: '8px', fontSize: 16 }}>
        {texts.step1Title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: '32px', maxWidth: 480, textAlign: 'center' }}
      >
        {texts.step1Description}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: '32px', minHeight: 24 }}>
        <CircularProgress size={16} thickness={5} />
        <Typography variant="body2" color="text.secondary">
          {rotatingText}
        </Typography>
      </Stack>

      <Box sx={{ width: '100%' }}>
        <OptimizationConfigPanel />
      </Box>
    </Stack>
  )
}
